import React from 'react'
import LoginForm from '../../forms/LoginForm'
import { Box, Card, CircularProgress } from '@mui/material'
import { useAuth } from 'src/auth/AuthProvider'
import './LoginView.scss'


const LoginView = () => {

    let auth = useAuth()

    return (
        <Box id="login-view">
            <Card sx={{ padding: 3 }} >
                {!auth.loaded &&
                    <Box sx={{ display: 'flex', justifyContent: 'center' }}>
                        <CircularProgress />
                    </Box>
                }
                {auth.loaded &&
                    <LoginForm />
                }
            </Card>
        </Box>
    )

}

export default LoginView